<template>
  <div :style="{height: mapheight, width: '100%'}">
    <iframe
      id="ProcessIframe"
      v-if="overviewType === '设备概貌图' && showGraph"
      :src="EquipmentIframeUrl"
      sandbox="allow-scripts allow-same-origin allow-top-navigation allow-popups"
      :style="{height: '100%', backgroundColor: nowImageBackground, width: '100%', border: 0}"
    ></iframe>
    <iframe
      id="ProcessOverviewIframe"
      v-else-if="overviewType === '工艺流程图' && showGraph"
      :src="ProcessIframeUrl"
      sandbox="allow-scripts allow-same-origin allow-top-navigation allow-popups"
      :style="{height: '100%', backgroundColor: nowImageBackground, width: '100%', border: 0}"
    ></iframe>

  </div>
</template>

<script>
import {timestampToTimeFormat} from "./TimeFormat";

export default {
  /**
   * 机组概貌图操作页的设备流程图、工艺概貌图、3D图所对应的iframeUrl
   */
  name: "OverViewIframe",
  props: ['overviewType', 'mapheight', 'nowImageBackground', 'initequid'],
  computed: {
    showGraph(){
      return this.$store.state.showGraph;
    },
    ProcessOverviewIP() {
      return this.changeUrl(this.$store.state.ProcessOverviewIP);
    },
    EquipmentIframeUrl() {
      return `${this.ProcessOverviewIP}/overview/${this.equid}`;
    },
    ProcessIframeUrl(){
      return `${this.ProcessOverviewIP}/flowchart/${this.equid}`;
    },
    getequName() {
      return this.$store.state.equName;
    },
    equid() {
      return this.$store.state.equid;
    },
    topiccolor() {
      return this.$store.state.topiccolor;
    },
    uid() {
      return this.$store.state.uid;
    },
    username() {
      return this.$store.state.username;
    },
    theme(){
      if (this.$store.state.topiccolor === 'white' || this.$store.state.topiccolor === 'simple-white'){
        return 'light'
      }else {
        return 'dark'
      }
    },
    gongyiOverviewIframeHistoryTime(){
      if (this.$store.state.gongyiOverviewIframeHistoryTime !== undefined && this.$store.state.gongyiOverviewIframeHistoryTime !== ' ' && this.$store.state.gongyiOverviewIframeHistoryTime !== null){
        return timestampToTimeFormat(this.$store.state.gongyiOverviewIframeHistoryTime);
      }else {
        return null;
      }
    },
  },
  watch: {
    gongyiOverviewIframeHistoryTime(newVal , oldVal){
      if (newVal !== oldVal || (newVal === null&&oldVal === null)){
        this.freshProcessOverviewIframe()
      }
    }
  },
  methods: {
    freshProcessOverviewIframe() {
      if (this.overviewType == '设备概貌图'){
        document.body.classList.add('iframe')
        if (this.gongyiOverviewIframeHistoryTime === undefined || this.gongyiOverviewIframeHistoryTime === ' ' || this.gongyiOverviewIframeHistoryTime === null){
          const param = {
            type: 'realtime',
            equipmentUuid: this.equid,
            view: 'lite',
            uid: this.uid,
            username: this.username
          }
          const wins = document.querySelector('#ProcessIframe')
          wins.contentWindow.postMessage(param, '*')
        }else {
          const param = {
            type: 'history',
            equipmentUuid: this.equid,
            time: this.gongyiOverviewIframeHistoryTime,
            view: 'lite',
            uid: this.uid,
            username: this.username
          }

          const win = document.querySelector('#ProcessIframe')
          win.contentWindow.postMessage(param, '*')
        }
      }else if (this.overviewType == '工艺流程图'){
        document.body.classList.add('iframe')
        if (this.gongyiOverviewIframeHistoryTime === undefined || this.gongyiOverviewIframeHistoryTime === ' ' || this.gongyiOverviewIframeHistoryTime === null){
          const param = {
            type: 'realtime',
            equipmentUuid: this.equid,
            view: 'lite',
            uid: this.uid,
            username: this.username
          }
          const winsPid = document.querySelector('#ProcessOverviewIframe')
          winsPid.contentWindow.postMessage(param, '*')
        }else {
          const param = {
            type: 'history',
            equipmentUuid: this.equid,
            time: this.gongyiOverviewIframeHistoryTime,
            view: 'lite',
            uid: this.uid,
            username: this.username
          }

          const winsPid = document.querySelector('#ProcessOverviewIframe')
          winsPid.contentWindow.postMessage(param, '*')
        }
      }

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ComUtils/OverViewIframe.vue